import React from 'react';
import './errorPage.scss';

export default class ErrorPage extends React.Component {

  render() {
    return (
      <div className="errorContent">
        <div>
          <h1><img src="/clapply/cyr/barclays-landscape_logo.gif" width="357" alt="Barclays Logo" frameBorder="0" />
          </h1>
        </div>
        <div>
          <h2>We apologize for the inconvenience, but our website is experiencing technical issues.</h2>
          <p>Please contact us at 1-877-437-3342 or try again later.</p>
        </div>
      </div>
    );
  }
}
